// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__eGUfZ","width":"Cards_width__3T5XP"};